import { render } from "./Kayttoehdot.vue?vue&type=template&id=727cc66a&ts=true"
import script from "./Kayttoehdot.vue?vue&type=script&lang=ts"
export * from "./Kayttoehdot.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__